import { GlobalAuthInfo } from '../../api/custom-instance';

const CYREN_ACCESS_TOKEN_KEY = 'cyren_access_token';

/**
 * TokenManager
 *
 * V2 Axios 토큰을 관리하는 싱글톤 클래스
 *
 * 관리하는 토큰 저장소:
 * 1. GlobalAuthInfo.AccessToken (V2 Axios)
 * 2. localStorage (브라우저 새로고침 복구용)
 * 3. Recoil AuthState.jwt는 use-auth.ts에서 직접 관리
 */
class TokenManager {
  private static instance: TokenManager;

  // eslint-disable-next-line no-useless-constructor
  private constructor() {}

  static getInstance(): TokenManager {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager();
    }
    return TokenManager.instance;
  }

  /**
   * 토큰 설정
   * V2 Axios 인스턴스와 localStorage에 토큰 적용
   */
  // eslint-disable-next-line class-methods-use-this
  setToken(token: string | null) {
    const tokenValue = token || '';

    if (tokenValue) {
      localStorage.setItem(CYREN_ACCESS_TOKEN_KEY, tokenValue);
    } else {
      localStorage.removeItem(CYREN_ACCESS_TOKEN_KEY);
    }

    // 1. V2 Axios 인스턴스
    GlobalAuthInfo.AccessToken = tokenValue;

    // Note: Recoil AuthState는 use-auth.ts에서 직접 관리
    // 여기서 Recoil을 업데이트하면 순환 참조 발생 가능
  }

  /**
   * 토큰 조회
   */
  // eslint-disable-next-line class-methods-use-this
  getToken(): string | null {
    const inMemoryToken = GlobalAuthInfo.AccessToken || null;
    if (inMemoryToken) {
      return inMemoryToken;
    }

    const persistedToken = localStorage.getItem(CYREN_ACCESS_TOKEN_KEY);
    if (persistedToken) {
      // 브라우저 새로고침 후에도 인터셉터가 동일 토큰을 즉시 사용하도록 복구한다.
      GlobalAuthInfo.AccessToken = persistedToken;
      return persistedToken;
    }

    return null;
  }

  /**
   * 토큰 삭제
   */
  clearToken() {
    this.setToken(null);
  }
}

export const tokenManager = TokenManager.getInstance();
